<template>
  <div
    class="step-button-panel"
    id="StepButtonPanel"
    :class="{
      'step-button-panel__single-button': !backVisible && !linkDashboardVisible,
    }"
  >
    <button
      class="button button--invert button--solid step-button-panel__button--back"
      @click.prevent="backPressed(owner)"
      v-if="backVisible"
    >
      tilbage
    </button>
    <button
      class="button step-button-panel__button--next"
      :class="[nextEnabled ? 'button--highlight' : 'button--disabled']"
      @click.prevent="nextPressed(owner)"
      v-if="nextVisible"
      :disabled="inProgress"
    >
      {{ nextButtonText }}
      <ButtonSpinner v-if="inProgress && nextPressedClicked" />
    </button>
    <button
      class="button button--invert button--solid step-button-panel__button--back"
      @click.prevent="goToDashboard(owner)"
      v-if="linkDashboardVisible"
      :disabled="inProgress"
    >
      til "mit biltorvet"
      <ButtonSpinner v-if="inProgress && goToDashboardClicked" />
    </button>
    <button
      class="button step-button-panel__button--publish"
      :class="[publishEnabled ? 'button--highlight' : 'button--disabled']"
      @click.prevent="publishPressed(owner)"
      v-if="publishVisible && !isActive"
      :disabled="inProgress"
    >
      udgiv nu
      <ButtonSpinner v-if="inProgress" />
    </button>
    <button
      class="button button--highlight step-button-panel__button--publish"
      @click.prevent="visitAdPressed(owner)"
      v-if="isActive && adUrl"
      :disabled="inProgress"
    >
      se annoncen
      <ButtonSpinner v-if="inProgress && visitAdPressedClicked" />
    </button>
  </div>
</template>
<script>
import { app } from '@/main'
import StepFunctions from '@components/PrivateAdFlow/Steps/StepFunctions.vue'
import ButtonSpinner from '@components/Shared/ButtonSpinner/ButtonSpinner.vue'
import { debounce } from '@/functions'

export default {
  components: {
    ButtonSpinner,
  },
  props: {
    eventBus: { default: null, type: Object },
    backVisible: { default: false, type: Boolean },
    nextVisible: { default: false, type: Boolean },
    nextEnabled: { default: false, type: Boolean },
    publishVisible: { default: false, type: Boolean },
    publishEnabled: { default: false, type: Boolean },
    isActive: { default: false, type: Boolean },
    isUpdate: { default: false, type: Boolean },
    adUrl: { default: null, type: String },
    dashboardUrl: { default: null, type: String },
    linkDashboardVisible: { default: false, type: Boolean },
    validateFunction: { default: null, type: Function },
  },
  data() {
    return {
      nextButtonText: 'Næste',
      inProgress: false,
      nextPressedClicked: false,
      goToDashboardClicked: false,
      visitAdPressedClicked: false,
      owner: this,
    }
  },
  methods: {
    backPressed: debounce(owner => {
      StepFunctions.back(owner.eventBus)
    }, 250),
    nextPressed: debounce(owner => {
      if (
        owner.validateFunction !== undefined &&
        owner.validateFunction !== null
      ) {
        if (!owner.validateFunction()) return
      }
      owner.inProgress = true
      owner.nextPressedClicked = true
      StepFunctions.next(owner.eventBus)
    }, 250),
    publishPressed: debounce(owner => {
      owner.inProgress = true
      StepFunctions.initiatePublish(app.mitt)
    }, 250),
    visitAdPressed: debounce(owner => {
      owner.inProgress = true
      owner.visitAdPressedClicked = true
      window.location.href = owner.adUrl
    }, 250),
    goToDashboard: debounce(owner => {
      owner.inProgress = true
      owner.goToDashboardClicked = true
      window.location.href = owner.dashboardUrl
    }, 250),
    releaseLock() {
      this.inProgress = false

      this.nextPressedClicked = false
      this.visitAdPressedClicked = false
      this.goToDashboardClicked = false
    },
    setLock() {
      this.inProgress = true
    },
  },
  created() {
    if (this.isUpdate) {
      this.nextButtonText = 'gem og fortsæt'
    }
    if (this.eventBus !== null) {
      this.eventBus.on('set-lock', this.setLock)
      this.eventBus.on('step-changed', this.releaseLock)
      this.eventBus.on('release-lock', this.releaseLock)
    }
    if (app.mitt) {
      app.mitt.on('overlay-closable', this.releaseLock)
    }
  },
}
</script>

<style lang="scss">
@import 'StepButtonPanel.scss';
</style>
